import './Team.css';

const team = [
  {
    name: 'Sundaresh Nageswaran',
    role: 'Co-Founder & Director',
    linkedin: 'https://www.linkedin.com/in/sundaresh-nageswaran/',
    photo: '/images/team/sundaresh.jpg',
    photoPosition: 'center 25%',
    expertise: 'Food & Agriculture Industry GTM',
    past: 'Sea6 Energy, Paper Boat, McCurrie Spices',
    education: 'IIT Roorkee, Indian School of Business',
  },
  {
    name: 'Amrut Nagasunder',
    role: 'Co-Founder & Director',
    linkedin: 'https://www.linkedin.com/in/anagasunder/',
    photo: '/images/team/amrut.jpg',
    expertise: 'AI, Tech, & Product Strategy',
    past: 'Google, Netflix, Mindmeld (acq. by Cisco)',
    education: 'NIT K, Carnegie Mellon University',
  },
  {
    name: 'Mahesh Kannan',
    role: 'Agribusiness & Commodities',
    linkedin: 'https://www.linkedin.com/in/maheshkannan312/',
    photo: '/images/team/mahesh.jpg',
    expertise: 'Agribusiness & Rural Management',
    past: 'Sea6 Energy, Dalmia Group, Daikin',
    education: 'PSG Tech, IRMA (MBA Rural Management)',
  },
  {
    name: 'Noor Thanveer',
    role: 'Product Operations',
    linkedin: 'https://www.linkedin.com/in/nmthoseyn/',
    photo: '/images/team/noor.jpg',
    expertise: 'Product Innovation & Supply Chain Ops',
    past: 'Nuts.com, Savory Hospitality, Hindustan Colas',
    education: 'VIT, New York University',
  },
];

function LinkedInIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
    </svg>
  );
}


export default function Team() {
  return (
    <section className="team" id="team">
      <div className="team-inner">
        <div className="team-header">
          <p className="section-label">Who we are</p>
          <h2 className="section-title">Leadership Team</h2>
          <div className="divider" />
          <p className="section-body">
            Aranyakam is led by a diverse team with deep roots in Agribusiness, Rural Enterprises,
            Supply Chains, Operations, Tech, and AI.
          </p>
        </div>
        <div className="team-grid" id="team">
          {team.map(m => (
            <div className="team-card" key={m.name}>
              <div className="team-photo-wrap">
                <img
                  src={m.photo}
                  alt={m.name}
                  className="team-photo"
                  style={m.photoPosition ? { objectPosition: m.photoPosition } : undefined}
                />
              </div>
              <div className="team-info">
                <div className="team-name-row">
                  <div>
                    <h3 className="team-name">{m.name}</h3>
                    <p className="team-role">{m.role}</p>
                  </div>
                  <a
                    href={m.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="team-linkedin"
                    aria-label={`${m.name} on LinkedIn`}
                  >
                    <LinkedInIcon />
                  </a>
                </div>
                <div className="team-meta">
                  <div className="team-meta-row">
                    <span className="team-meta-label">Expertise</span>
                    <span className="team-meta-value">{m.expertise}</span>
                  </div>
                  <div className="team-meta-row">
                    <span className="team-meta-label">Experience</span>
                    <span className="team-meta-value">{m.past}</span>
                  </div>
                  <div className="team-meta-row">
                    <span className="team-meta-label">Education</span>
                    <span className="team-meta-value">{m.education}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
